import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import LandingPage from '../components/home/LandingPage';
import Intro from '../components/home/Intro';
import trainerKettlebell from '../assets/images/trainer-kettlebell.jpg'
import introFood from '../assets/images/intro-food.jpg'
import Coaching from '../components/home/Coaching'
import ProgramExplanation from '../components/home/ProgramExplanation'
import FAQ from '../components/home/FAQ'
import ContactForm from '../components/home/ContactForm'

import sales from '../sellingApi'
import Testimonials from '../components/home/Testimonials';

function Home() {
  const { t } = useTranslation();
  const [focus, setFocus] = useState(null);
  const faqItems = t('home.faq.items', { returnObjects: true });
  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };
  return (
    <div>
      <SEO
        title={t('seo.home.title')}
        description={t('seo.home.description')}
        path="/"
        jsonLd={faqJsonLd}
      />
      <Navbar />
      <div className='relative' id="topOfHome">
        <LandingPage setFocus={setFocus}/>
      </div>
      <ProgramExplanation></ProgramExplanation>
      <div id="1on1coaching">
        {sales.coachings.map((coaching) => (
          <Coaching key={coaching.id + coaching.name} coaching={coaching} focus={focus}/>
        ))}
      </div>
      <Intro
        location="left"
        img={trainerKettlebell}
        description="Trainer with kettlebells"
        title={t('home.intro.training.title')}
        text={t('home.intro.training.text')}
        pathname="/training"
      />
      <Intro
        img={introFood}
        description="healthy food"
        title={t('home.intro.nutrition.title')}
        text={t('home.intro.nutrition.text')}
        pathname="/nutrition"
      />
        <div id="testimonials">
          <Testimonials/>
        </div>
        <div className='bg-coaching-blue bg-opacity-5'>
          <div className='max-w-7xl mx-auto px-6 lg:px-12 py-8'>
            <h2 className='pb-8 text-xl font-bold text-center'>{t('home.faq.title')}</h2>
            {faqItems.map((item, index) => (
              <FAQ key={index} question={item.question} answer={item.answer} />
            ))}
          </div>
        </div>
        <div id="contact">
          <ContactForm />
        </div>
      <Footer />
    </div>
  );
}

export default Home;
